export default __webpack_public_path__ + "static/media/img--design-3.e661fbb8.jpg";